<template>
  <router-view />
  <ConfirmDialogHost />
</template>

<script>
import ConfirmDialogHost from './components/ConfirmDialogHost.vue'

export default {
  name: 'App',
  components: {
    ConfirmDialogHost
  }
}
</script>

<style>
@import './styles/caomu-theme.css';
@import './styles/moment-module.css';
@import './styles/mobile-home.css';
@import './styles/admin-dashboard.css';
@import './styles/emoji-picker.css';
@import './styles/weather-card.css';
</style>
